import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout, DimensionTabLayout, UserDefinedFormLayoutCodes, UserDefinedFormLayoutReference,IMPrimaryLayout } from '../Layout';
import { combinedLayouts } from "../../../../common/Utils";
import { IM, WM } from "../../../../const/constants";


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const layouts = [
        { name: 'PrimaryLayout', layout: props.Module===WM? PrimaryLayout :props.Module ===IM ? IMPrimaryLayout : PrimaryLayout },
        { name: 'DimensionTabLayout', layout: DimensionTabLayout },
        { name: 'UserDefinedFormLayoutCodes', layout: UserDefinedFormLayoutCodes },
        { name: 'UserDefinedFormLayoutReference', layout: UserDefinedFormLayoutReference },
    ];

    const finalLayout = combinedLayouts(layouts);
    const handlePrimaryFormLoads = useCallback(() => {
        props.handlePrimaryFormLoad(formRefs);

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e, formRefs);

    }, []);
    useEffect(() => {
        if (formRefs.current['RProfile']) {
            if (props.formFields.RowId !== "00000000-0000-0000-0000-000000000000") 
                { formRefs.current['RProfile'].instance().option('disabled', true); }
            else { formRefs.current['RProfile'].instance().option('disabled', false); }
        }
    }, [props.formFields,formRefs.current['RProfile']]);
    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId={props.Module===WM?'b0866bc0-0acb-4b14-a624-ae3620f86f13':'1c4f3d2e-4f7e-4e2e-9c8b-5f7e3d2e1c4f'}
                layoutName='WMTransactionDataEntryPrimayForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handlePrimaryFormLoads}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
